export default __webpack_public_path__ + "static/media/trending_up.0976d83d.svg";